import StatusHandler from 'app/shared-components/StatusHandler'

import useGetBillingCompany from '../hooks/useGetBillingCompany'
import BillingCompanyForm from '../BillingCompanyForm'

const Overview = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetBillingCompany(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <BillingCompanyForm
                data={data}
                disabled
            />
        </StatusHandler>
    )
}

export default Overview
